if (!window.dAgency) window.dAgency = {};

window.dAgency.initDesktopSlider = (slider, scrollMultiplier = 2) => {
  var isDown = false;
  var startX;
  var scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * scrollMultiplier;
    slider.scrollLeft = scrollLeft - walk;
  });
};
